function InboxDetail() {
  return <div>Inbox Detail</div>;
}

export { InboxDetail as default };
